import React from 'react';

import { ItemBlockedOverlay } from '~/app/components/ItemPage/components/ItemBlockedOverlay';
import { selectUserCountry } from '~/app/lib/store/session/selectors';
import PrimaryButton from '~/app/components/Button/PrimaryButton';
import { REQUIRED_PRIVACY_POLICY_TEXTS } from '~/app/lib/privacy';
import { PRIVACY_POLICY_COOKIE_NAME } from '~/config';
import { useSelector } from '~/app/lib/store/redux';
import { useI18n } from '~/app/lib/i18n';
import Text from '~/app/components/Text';
import Box from '~/app/components/Box';

import { UsePageGateResult } from './usePageGate';

interface PrivacyPolicyGateProps {
  unlockPageGate: UsePageGateResult['unlock'];
}

export const PrivacyPolicyGate = ({
  unlockPageGate,
}: PrivacyPolicyGateProps) => {
  const country = useSelector(selectUserCountry);
  const { t } = useI18n('app');

  const texts =
    country in REQUIRED_PRIVACY_POLICY_TEXTS
      ? REQUIRED_PRIVACY_POLICY_TEXTS[country]
      : undefined;

  return (
    <ItemBlockedOverlay
      testId="privacyPolicyGate"
      style={{ width: '80%', height: '80%', overflowY: 'auto' }}
    >
      <Box style={{ maxHeight: '85%', maxWidth: '800px', margin: '0 auto' }}>
        <Box
          style={{
            display: 'flex',
            maxHeight: '80%',
            marginBottom: '4rem',
          }}
        >
          <Column text={texts?.en ?? ''} />
          <Column text={texts?.local ?? ''} />
        </Box>
        <PrimaryButton
          testId="acceptPrivacyPolicy"
          text={t('actions.accept')}
          height="4.8rem"
          style={{ width: '50%', margin: '0 auto' }}
          onClick={() => {
            unlockPageGate(PRIVACY_POLICY_COOKIE_NAME, 'true', 30);
          }}
        />
      </Box>
    </ItemBlockedOverlay>
  );
};

const Column = ({ text }: { text: string }) => (
  <Box
    style={{
      flex: '1 0 50%',
      padding: '10px 20px 100px 10px',
      width: '50%',
      overflowY: 'auto',
      position: 'relative',
      maskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)',
      WebkitMaskImage:
        'linear-gradient(to bottom, black 70%, transparent 100%)',
    }}
  >
    <Text>{text}</Text>
  </Box>
);
